import API from "@/models/API";

export default class RegistrationPlans {
    constructor(item = {}) {
        this.store_subscription_plan_id = item.store_subscription_plan_id || null;
        this.plan_name = item.plan_name || {
            el: "",
            en: "",
            it: ""
        };
        this.plan_description = item.plan_description || {
            el: "",
            en: "",
            it: ""
        };
        this.plan_price = item.plan_price || null;
        this.interval = item.interval || "";
        this.interval_count = item.interval_count || null;
        this.reward_points = item.reward_points || null;
        this.reward_type_id = item.reward_type_id || null;
        this.store_payment_methods = item.store_payment_methods || [];
        this.is_public = item.is_public || false;
        this.extra_properties = item.extra_properties || {
            is_pos: false
        }
        this.attributes = item.attributes || {}
        this.vat_included = item.vat_included || false;
        this.permissions = item.permissions || {}
    }

    static get = (query) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/subscriptions/plans${query}`);

    static getProfile = (id) =>
        API.get(`/companies/${localStorage.getItem("storeId")}/subscriptions/plans/${id}`);

    static getPlanTypes = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/subscriptions/system-plan-types`);

    static getRewardTypes = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/subscriptions/reward-types`);

    static getStoreAttributes = () =>
        API.get(`/companies/${localStorage.getItem("storeId")}/subscriptions/store-attributes`);

    static create = (item) =>
        API.post(`/companies/${localStorage.getItem("storeId")}/subscriptions/store-plan`,item);

    static update = (item,id) =>
        API.put(`/companies/${localStorage.getItem("storeId")}/subscriptions/store-plan/${id}`,item);

    static updateCompany = (item,id) =>
        API.put(`/companies/${localStorage.getItem("storeId")}/subscriptions/company-plan/${id}`,item);

    static delete = id =>
        API.delete(
            `/companies/${localStorage.getItem("storeId")}/subscriptions/plans/${id}`
        );
    static getPermissions = () =>
        API.get(`/users/default-permissions`);
}
